export default __webpack_public_path__ + "static/media/border-join-round-17.16630c14.svg";